<apex-page-info [title]="title"></apex-page-info>

<apex-case-view [id]="id"> </apex-case-view>
